import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../Basic/Buttons/Button';
import H2 from '../../../Basic/WrapsStyle/H/H2';
import Row from '../../../Basic/Blocks/Row';
import Text from '../../../Basic/WrapsStyle/Text';
import { MARKETS_MAP, TYPE_BUTTONS } from '../../../../constans';

import UserApi from '../../../../API/user/user-api';
import { addStaff } from '../../../../actions/staff';
import H3 from '../../../Basic/WrapsStyle/H/H3';
import styles from './styles.module.scss';
import PopUp from '../../../Basic/Blocks/PopUp';
import CheckButton from '../../../Basic/Buttons/Check';

export const MAP_MARKET = MARKETS_MAP;
const AccessContentUserPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [providers, setProviders] = useState([]);
  const [providersMap, setProvidersMap] = useState({});

  let [listProvider, setListProvider] = useState([]);
  const [marketsMap, setMarketsMap] = useState({});

  const allProviders = useSelector((store) => store.providers);

  const clickChange = () => {
    console.log(data);
    UserApi.changeUser({
      data: {
        login: user.login,
        data: {
          access_providers: Object.keys(providersMap)
            .filter((key) => providersMap[key].flag)
            .map((item) => parseInt(item)),
          access_shops: Object.keys(marketsMap).filter((key) => marketsMap[key].flag),
        },
      }
    })
      .then(() => {
        UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
        close();
      })
      .catch();
  };

  useEffect(() => {
    setData(user.access);

    console.log(user);
  }, [user]);

  useEffect(() => {
    let access_providers = user.access_providers || [];
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      let map = {};
      p.forEach((item) => {
        map[item.id] = { id: item.id, name: item.name, flag: access_providers.includes(item.id) };
      });
      setProvidersMap(map);
    } else {
    }
  }, [allProviders, user.access_providers]);

  useEffect(() => {
    let access_shops = user.access_shops || [];
    let map = {};

    Object.keys(MARKETS_MAP).forEach((market) => {
      map[MARKETS_MAP[market]] = {
        shop: MARKETS_MAP[market],
        flag: access_shops.includes(MARKETS_MAP[market]),
      };
    });
    setMarketsMap(map);
  }, [user.access_shops]);

  useEffect(() => {
    let sorted = [...Object.keys(providersMap)]
      .map((key) => ({ key: providersMap[key].id, name: providersMap[key].name, flag: providersMap[key].flag }))
      .sort((a, b) => (a.name > b.name ? 1 : -1))
      .filter((item) => item.name);
    setListProvider(sorted);
  }, [providersMap]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
        <H2 style={{ marginBottom: '10px' }}>Настройка доступов для контента {user.login}</H2>

        <H3 style={{ margin: '15px 0' }}>Поставщики</H3>
        <div className={styles.block_markets}>
          {listProvider.map((item) => {
            return (
              <Row className={styles.block_small} key={item.key}>
                <Text fontSize={16} style={{ marginRight: '15px', width: '160px' }}>
                  {item.name}
                </Text>
                <CheckButton
                  checked={item.flag}
                  onSelect={() =>
                    setProvidersMap({
                      ...providersMap,
                      [item.key]: { ...item, id: item.key, flag: !item.flag },
                    })
                  }
                />
              </Row>
            );
          })}
        </div>
        <H3 style={{ margin: '15px 0' }}>Магазины</H3>
        <div className={styles.block_markets}>
          {Object.keys(marketsMap)
            .filter((key) => marketsMap[key])
            .map((key) => {
              return (
                <Row className={styles.block_small} key={key}>
                  <Text fontSize={16} style={{ marginRight: '15px', width: '160px' }}>
                    {marketsMap[key].shop}
                  </Text>
                  <CheckButton
                    checked={marketsMap[key].flag}
                    onSelect={() =>
                      setMarketsMap({
                        ...marketsMap,
                        [key]: { ...marketsMap[key], flag: !marketsMap[key].flag },
                      })
                    }
                  />
                </Row>
              );
            })}
        </div>
        <Row style={{ marginTop: '30px' }}>
          <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={clickChange}>
            Сохранить
          </Button>
          <Button type={TYPE_BUTTONS.GREY} onClick={close}>
            Отменить
          </Button>
        </Row>
    </PopUp>
  );
};

export default AccessContentUserPopUp;
